module.exports = __webpack_public_path__ + "static/media/sab.5d569c3b.webp";